import { ChannelType } from "../../../src/models/ChannelType";
import Connection from "../../../src/models/Connection";
import Group from "../../../src/models/Group";
import type Room from "../../../src/models/Room";

/** Links contacts only to shading consumers belonging to the same window or door. */
export function connectOpeningContacts(owner: Room | Group): void {
  if (!(owner instanceof Group) || owner.groupType !== "opening") return;
  const contacts = owner.consumers.filter((consumer) => consumer.channelType === ChannelType.Lock);
  const shading = owner.consumers.filter(
    (consumer) => consumer.channelType === ChannelType.Jalousie || consumer.channelType === ChannelType.Blind,
  );
  for (const contact of contacts) {
    for (const consumer of shading) {
      const connected = contact.connections.findFirst(
        (connection) =>
          (connection.fromDevice === contact && connection.toDevice === consumer) ||
          (connection.fromDevice === consumer && connection.toDevice === contact),
      );
      if (!connected) Connection.createConnection(contact, consumer);
    }
  }
}
